export default __webpack_public_path__ + "static/media/Success.675a0ecc.png";